import { z } from "@/helpers/forms/zod";

export const qualifyDrawerFormSchema = z.object({
  productId: z.number(),
  deliverableId: z.number(),
  productName: z.string(),
  fields: z.record(z.string(), z.any()),
  withPreMedia: z.boolean(),
});

export type QualifyDrawerFormType = z.infer<typeof qualifyDrawerFormSchema>;
